import { render, staticRenderFns } from "./FileSender.vue?vue&type=template&id=1d682768"
import script from "./FileSender.vue?vue&type=script&lang=js"
export * from "./FileSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports